export function countdown() {
  const els = document.querySelectorAll('.js-countdown-el');
  if(els.length) {
    els.forEach((el,index) => {
      // ターゲットの日時を 'YYYY-MM-DD' 形式で指定します
      const targetDateString = '2024-06-14';

      // タイムゾーンを日本（JST, UTC+9）に設定
      const targetDate = new Date(targetDateString + 'T00:00:00+09:00');

      // 指定した日時までの日数を計算し、コンソールに表示する関数
      function updateDaysLeft() {
      // 現在の日時を取得（日本時間に変換）
      const now = new Date();
      const nowJST = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (9 * 3600000));

      // 現在の日時とターゲットの日時の差を計算（ミリ秒）
      const diff = targetDate - nowJST;

      // ミリ秒を日数に変換
      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

      // 結果を表示
      el.innerText = `${days}`;
      }

      // 1秒ごとに日数を更新
      setInterval(updateDaysLeft, 1000);
    })
  }
}